import './index.styl';
import template from './index.jst';
import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';
import _ from 'lodash';

const tippingChannel = Radio.channel('tipping');

export class WidgetStreakTracker extends View {
	get template() {
		return template;
	}

	get className() {
		return 'widget-streak-tracker';
	}

	initialize(){
		this.model.set({
			is_know_status: false,
			is_active: true,
			season_completed: false,
		});

		this.listenTo(this.model, 'change', this.render);
		this.listenTo(tippingChannel, 'streak:update', this.update);
	}

	update({ is_active, season_completed }){
		this.model.set({
			is_know_status: !_.isUndefined(is_active),
			is_active: is_active,
			season_completed,
		});
	}
}

export default WidgetStreakTracker;